<template>
  <div>
    <div class="toolbar">
      <el-select v-model="createdBy" clearable filterable placeholder="人员" style="width:160px">
        <el-option
          v-for="u in users"
          :key="u.id"
          :label="u.workerName || u.nickname || u.username"
          :value="u.id"
        />
      </el-select>
      <el-select v-model="signinType" clearable placeholder="人员角色" style="width:140px">
        <el-option label="项目经理" value="PM" />
        <el-option label="工人" value="WORKER" />
      </el-select>
      <el-select v-model="punchType" clearable placeholder="签到方式" style="width:140px">
        <el-option label="巡检签到" value="INSPECT" />
        <el-option label="考勤签到" value="SIGN_IN" />
        <el-option label="考勤签退" value="SIGN_OUT" />
      </el-select>
      <el-date-picker
        v-model="startDate"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="开始日期"
        style="width:150px"
      />
      <el-date-picker
        v-model="endDate"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="结束日期"
        style="width:150px"
      />
      <el-select v-model="projectId" clearable filterable placeholder="筛选项目" style="width:180px">
        <el-option
          v-for="p in projects"
          :key="p.id"
          :label="p.name || p.customerName"
          :value="p.id"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button icon="el-icon-download" :loading="exporting" :disabled="!list.length" @click="onExport">导出</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading">
      <el-table-column type="index" label="序号" width="55" align="center" />
      <el-table-column prop="createdAt" label="签到时间" width="170">
        <template slot-scope="{ row }">{{ fmtDateTime(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column prop="createdByName" label="人员" width="110" />
      <el-table-column prop="projectName" label="项目" min-width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <project-name-link :project-id="row.projectId" :name="row.projectName" />
        </template>
      </el-table-column>
      <el-table-column label="签到方式" width="110" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="punchTagType(row.punchType)">
            {{ punchLabel(row.punchType) || row.punchTypeName || '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="genposition" label="地理位置" min-width="140" show-overflow-tooltip />
      <el-table-column prop="address" label="详细地址" min-width="180" show-overflow-tooltip />
      <el-table-column prop="signinType" label="人员角色" width="110" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.signinType === 'SUPERVISOR' ? 'success' : (row.signinType === 'WORKER' ? 'warning' : '')">
            {{ typeLabel(row.signinType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="90" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog title="查看签到" :visible.sync="detailVisible" width="720px" top="6vh" @closed="onDetailClosed">
      <el-form :model="detail" label-width="90px" size="small">
        <el-form-item label="签到时间">
          <el-input :value="fmtDateTime(detail.createdAt)" readonly />
        </el-form-item>
        <el-form-item label="人员">
          <el-input :value="detail.createdByName || '-'" readonly />
        </el-form-item>
        <el-form-item label="项目">
          <el-input :value="detail.projectName || '-'" readonly />
        </el-form-item>
        <el-form-item label="地理位置">
          <el-input :value="detail.genposition || '-'" readonly />
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input :value="detail.address || '-'" readonly />
        </el-form-item>
        <el-form-item label="签到方式">
          <el-input :value="punchLabel(detail.punchType) || detail.punchTypeName || '-'" readonly />
        </el-form-item>
        <el-form-item label="人员角色">
          <el-input :value="typeLabel(detail.signinType)" readonly />
        </el-form-item>
      </el-form>
      <div v-if="mapSrc" class="map-wrap">
        <iframe class="map-frame" :src="mapSrc" frameborder="0" scrolling="no" title="签到位置" />
        <div class="map-tip">内嵌地图（OpenStreetMap）。接入商业地图 Key 后可替换为高德/百度。</div>
      </div>
      <div v-else class="map-empty">暂无经纬度，无法展示地图</div>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listProjectSignins, exportProjectSignins, getProjectSignin, listProjects } from '../../api/project'
import { listUsers } from '../../api/sys'
import ListPagination from '../../components/ListPagination.vue'
import ProjectNameLink from '../../components/ProjectNameLink.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'ProjectSignin',
  components: { ListPagination, ProjectNameLink },
  mixins: [listPaging],
  data() {
    return {
      loading: false,
      exporting: false,
      list: [],
      users: [],
      projects: [],
      createdBy: null,
      projectId: null,
      signinType: '',
      punchType: '',
      startDate: '',
      endDate: '',
      detailVisible: false,
      detail: {},
      mapSrc: ''
    }
  },
  created() {
    this.loadUsers()
    this.loadProjects()
    this.load()
  },
  methods: {
    typeLabel(t) {
      if (t === 'SUPERVISOR' || t === '1') return '监理'
      if (t === 'WORKER') return '工人'
      return '项目经理'
    },
    punchLabel(t) {
      const map = { INSPECT: '巡检签到', SIGN_IN: '考勤签到', SIGN_OUT: '考勤签退' }
      return map[t] || ''
    },
    punchTagType(t) {
      if (t === 'SIGN_IN') return 'success'
      if (t === 'SIGN_OUT') return 'warning'
      return ''
    },
    fmtDateTime(v) {
      if (!v) return '-'
      const s = String(v)
      return s.length >= 19 ? s.slice(0, 19).replace('T', ' ') : s.replace('T', ' ')
    },
    async loadUsers() {
      try {
        const res = await listUsers({ includeWorker: true })
        this.users = res.data || []
      } catch (e) {
        this.users = []
      }
    },
    async loadProjects() {
      try {
        const res = await listProjects({})
        this.projects = res.data || []
      } catch (e) {
        this.projects = []
      }
    },
    async load() {
      this.loading = true
      try {
        const res = await listProjectSignins(this.queryParams())
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    queryParams() {
      return {
        createdBy: this.createdBy || undefined,
        projectId: this.projectId || undefined,
        signinType: this.signinType || undefined,
        punchType: this.punchType || undefined,
        startDate: this.startDate || undefined,
        endDate: this.endDate || undefined
      }
    },
    async onExport() {
      if (!this.list.length) {
        return this.$message.warning('暂无数据可导出')
      }
      this.exporting = true
      try {
        const res = await exportProjectSignins(this.queryParams())
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '项目签到.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    },
    buildMapSrc(lat, lng) {
      const latitude = Number(lat)
      const longitude = Number(lng)
      if (Number.isNaN(latitude) || Number.isNaN(longitude)) return ''
      const delta = 0.01
      const minLon = longitude - delta
      const minLat = latitude - delta
      const maxLon = longitude + delta
      const maxLat = latitude + delta
      return (
        'https://www.openstreetmap.org/export/embed.html?bbox=' +
        minLon +
        '%2C' +
        minLat +
        '%2C' +
        maxLon +
        '%2C' +
        maxLat +
        '&layer=mapnik&marker=' +
        latitude +
        '%2C' +
        longitude
      )
    },
    async openDetail(row) {
      this.detail = { ...(row || {}) }
      this.mapSrc = this.buildMapSrc(row.latitude, row.longitude)
      this.detailVisible = true
      try {
        const res = await getProjectSignin(row.id)
        if (res.data) {
          this.detail = res.data
          this.mapSrc = this.buildMapSrc(res.data.latitude, res.data.longitude)
        }
      } catch (e) {
        // keep list row data
      }
    },
    onDetailClosed() {
      this.detail = {}
      this.mapSrc = ''
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  align-items: center;
}
.map-wrap {
  margin-top: 8px;
}
.map-frame {
  width: 100%;
  height: 360px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
}
.map-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #94a3b8;
}
.map-empty {
  margin-top: 8px;
  padding: 40px 0;
  text-align: center;
  color: #94a3b8;
  background: #f8fafc;
  border-radius: 4px;
}
</style>
